import React from 'react'
import { SaveButton } from '../../../../../../../../../itrust_common/components/others'
import { connect, useDispatch } from 'react-redux'
import { visionInsuranceClaimFormEdit } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'

function EyefinityFormButton(props) {
  const { saving, buttonClasses, visionInsuranceClaimForm, editing: { activeTab }, actionLabel } = props
  const dispatch = useDispatch()
  const buttonLabel = actionLabel || (activeTab === 'final' ? 'Save' : 'Next')

  const handleBackClick = () => {
    const activeModulesArr = visionInsuranceClaimForm?.eligibility?.data.map(item => item.active && item.service_type ? item.service_type : '') || []
    const step2Modules = ['Lens', 'Frame', 'Contact Lens', 'Contact Lens Service']
    const hasStep2 = activeModulesArr.some(m => step2Modules.includes(m))

    let backTab = 'first'
    if (activeTab === 'final') {
      backTab = hasStep2 ? 3 : 2
    } else if (activeTab === 3) {
      backTab = 2
    } else if (activeTab === 2) {
      backTab = 'first'
    }

    dispatch(visionInsuranceClaimFormEdit({ activeTab: backTab }))
  }

  return (
    <div className='d-flex justify-content-end mt-6'>
      {activeTab !== 'first' && <button type="button" className='btn btn-outline-primary mr-5 px-7' onClick={handleBackClick}>Back</button>}
      <SaveButton saving={saving} buttonClasses={`px-7 ${buttonClasses}`} label={buttonLabel} />
    </div>
  )
}

const mapStateToProps = (state) => {
  const { visionInsuranceClaimForm: { visionInsuranceClaimForm, saving, editing } } = state

  return {
    visionInsuranceClaimForm,
    saving,
    editing
  }
}

export default connect(mapStateToProps)(EyefinityFormButton)
